const freqAndDuration=[


    {
    label:"Frequency",
    controlType:"radio button",
    options:[" Every day","Most days", "Weekly", "Every couple of weeks", "Monthly", "Occasionally"]
    },

    {
    label:"Present for several:",
    controlType:"radio button",
    options:["Days","Weeks","Months","Years"]
    }


]

export default freqAndDuration